import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetPersistedTranslations(
    $id: ID
    $namespaces: [Namespace!]!
    $locale: Language!
  ) {
    translations(id: $id, namespaces: $namespaces, locale: $locale)
  }
`);
